import { render, staticRenderFns } from "./business-category-select.vue?vue&type=template&id=337cacb5&"
import script from "./business-category-select.vue?vue&type=script&lang=js&"
export * from "./business-category-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports